export function matchesRole(
  roleFilter: string | undefined | null,
  role: string | undefined | null
) {
  return roleFilter == null || roleFilter === role;
}
